module.exports = __webpack_public_path__ + "img/9788990220486.b068e2b9.jpg";